import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetImageData = (data: any) =>
    request({
        url: ApiURL.Query.getImageV2Datas,
        method: RequestType.POST,
        data: data,
    });

const ImageSearchV2ServiceQuery = {
    GetImageData,
};

export default ImageSearchV2ServiceQuery;
